export default __webpack_public_path__ + "static/12-6d61c9559554ed2684584901082ddbe9.webp";